// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-form[data-v-44392c36]{padding-top:10px}.el-form .el-form-item[data-v-44392c36]:nth-child(-n+2){margin-bottom:30px}[data-v-44392c36] .el-form .el-form-item:last-child{margin-bottom:16px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
